import { useContext } from 'react';
import BodyRow from './BodyRow';
import BodyCell from './BodyCell';

import { TableContext } from '../../TableContext';

export default function TableBody({ withBorderRadius = '0' }) {
  const ctx = useContext(TableContext);

  return (
    <div
      style={{
        width: '100%',
        overflow: 'hidden',
        borderRadius: withBorderRadius,
        ...ctx.bodyStyles
      }}
    >
      {ctx?.data?.map((row) => (
        <BodyRow key={row.Id} row={row}>
          {ctx.columns()?.map((column) => (
            <BodyCell key={column.id} alignment={column?.alignment}>
              {column.value(row)}
            </BodyCell>
          ))}
        </BodyRow>
      ))}
    </div>
  );
}
